export default "__VITE_ASSET__Bprz1KRL__"